import {observer} from 'mobx-react';
import LieuTimeNote from './LieuTimeNote';

const OvertimeCell = observer(({model}) => {
  return (
    <div>
      <div>{model.overtime}</div>
      <LieuTimeNote lieuTime={model.overtimeLieuTime}/>
    </div>
  );
});

export default OvertimeCell;
